__webpack_require__.p = "https://bmidxblatviaplpreprod.netlify.app/";